module.exports = __webpack_public_path__ + "static/media/UN-01.afc1f20e.jpg";